

<mat-card >
    <!-- <mat-card-header> -->
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <!-- <mat-card-title>
          <mat-form-field class="input-full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" [(ngModel)]="location.name" />
          </mat-form-field>
        </mat-card-title>
        <mat-card-subtitle>
            <mat-form-field class="input-full-width">
                <mat-label>Description</mat-label>
                <input matInput type="text" [(ngModel)]="location.description" />
            </mat-form-field>
        </mat-card-subtitle> -->
    <!-- </mat-card-header> -->
    
    <mat-card-content>
        <mat-card>
            <div class="addr-map-container">

                <div class="addr-left-container">
                    <div class="address">
                        <p>
                            <mat-form-field class="input-full-width">
                                <mat-label>Location Name:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.name" (ngModelChange)="onChange()" />
                            </mat-form-field>
                        </p>
                        <p>
                            <mat-form-field class="input-full-width" >
                                <mat-label>Visible In App</mat-label>
                                <mat-select [(ngModel)]="location.visibility">
                                    <mat-option value="private">No</mat-option>
                                    <mat-option value="public">Yes</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </p>
                        <p>
                            <mat-form-field class="input-full-width">
                                <mat-label>Address Line 1:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.address1" (ngModelChange)="onChange()" />
                            </mat-form-field>
                        </p>
                        <p>
                            <mat-form-field class="input-full-width" *ngIf="location.address1">
                                <mat-label>Address Line 2:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.address2" (ngModelChange)="onChange()"/>
                            </mat-form-field>
                        </p>
                        <p>
                            <mat-form-field class="input-full-width" *ngIf="location.address2">
                                <mat-label>Address Line 3:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.address3" (ngModelChange)="onChange()"/>
                            </mat-form-field>
                        </p>
                            <mat-form-field class="input-full-width">
                                <mat-label>City:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.city" (ngModelChange)="onChange()"/>
                            </mat-form-field>
                            <p>
                            <mat-form-field class="input-full-width">
                                <mat-label>State:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.state" (ngModelChange)="onChange()" />
                            </mat-form-field>
                        </p><p>
                            <mat-form-field class="input-full-width">
                                <mat-label>Postal Code:</mat-label>
                                <input matInput type="text" [(ngModel)]="location.postalCode" (ngModelChange)="onChange()" />
                            </mat-form-field>
                            </p>                    </div>
                    <div class="geofence-container" >
                        <span>Geofence Radius: {{ location.geofenceRadiusKM }}km</span>
                        <div>
                            <mat-slider step=".001" min=".01" max="2" [(ngModel)]="location.geofenceRadiusKM" (ngModelChange)="updateRadius()"></mat-slider>
                        </div>
                    </div>
                </div>
                <div class="map-container" >
                    <mat-progress-spinner class="inner" *ngIf="!mapOptions && mapVisible"
                    mode="indeterminate"></mat-progress-spinner>
                    <google-map #map width="400px" height="400px" *ngIf="mapOptions" [options]="mapOptions">
                        <map-marker 
                        [position]="mapMarkerLocation"></map-marker>
                        <map-circle [center]="mapMarkerLocation"
                                    [radius]="location.geofenceRadiusKM*1000" 
                                    [options]="circleOptions"
                                    ></map-circle>
                    </google-map>
                </div>
            </div>
        </mat-card>
    </mat-card-content>
    <mat-card-actions>
        <button *ngIf="location.id" mat-button color="warn" (click)="deleteLocation()" >Delete this location</button>
        <button *ngIf="!location.id" mat-button color="warn" (click)="deleteLocation()" >Undo Adding Location</button>
    </mat-card-actions>
</mat-card>
